import React, { Component } from 'react';
import { connect } from 'react-redux';

import './../../../css/search-form.css';

class SearchForm extends Component {
	showLogo() {
		if (this.props.siteInfo.isLoading) {
			return <div />;
		} else if (this.props.siteInfo.site.logo) {
			return (
				<a className="top_logo" href="https://shop.fireoneup.com">
					<img src={this.props.siteInfo.site.logo} alt={this.props.siteInfo.site.title} />
				</a>
			);
		} else {
			return null;
		}
	}

	render() {
		let Logo = this.showLogo();
		return <div>{Logo}</div>;
	}
}

const mapStateToProps = (state) => {
	return {
		siteInfo: state.siteInfo,
	};
};

export default connect(mapStateToProps)(SearchForm);



// WEBPACK FOOTER //
// ./src/components/header/LogoSection/HeaderLogo.js